const TimeOfDayOptions = (customActionAm, customActionPm, customActionAnytime) => {

    return (
             [
              {
                label: customActionAm,
                value: 'AM',
              },
              {
                label: customActionPm,
                value: 'PM',
              },
              {
                label: customActionAnytime,
                value: 'Any Time',
              },
            ]
          )
  }

  export default TimeOfDayOptions;